import styled, { css } from "styled-components";
import {
  colors,
  screenSizes,
  typography as T
} from "@streeteasy/design-system";
import TextAction, {
  textActionTypography
} from "@streeteasy/design-system/text-action";

import { skyline } from "../../assets";

export const Wrapper = styled.div`
  background: ${colors.GRAY_DARK};
  color: ${colors.WHITE};
  padding-top: 58px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    padding-top: 26px;
  }
`;

export const Footer = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  position: relative;

  ${({ isExpandedAreaSection }) =>
    !isExpandedAreaSection && `align-items: flex-start;`}

  ${({ isWide }) =>
    isWide
      ? css`
          max-width: 1376px;
          padding: 0 28px;
        `
      : css`
          width: 984px;
        `}

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    padding: 0 52px;
    width: initial;
  }
`;

export const HR = styled.hr`
  background: ${colors.WHITE}32;
  border: 0;
  height: 1px;
  width: 100%;

  ${({ isExpandedAreaSection }) =>
    !isExpandedAreaSection && `margin: 30px 0 0;`}

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    display: none;
  }
`;

export const ComplianceText = styled(T.Caption)`
  color: inherit;
  max-width: 517px;
  padding-top: ${props => (props.isExpandedAreaSection ? "45px" : "24px")};
  text-align: center;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    padding-top: 48px;
  }
`;

export const ComplianceLink = styled(TextAction).attrs({
  target: "_blank",
  typography: textActionTypography.CAPTION
})`
  &,
  &:active,
  &:hover {
    background: inherit;
    color: inherit;
  }
`;

export const CopyrightSection = styled(ComplianceText)`
  margin-bottom: 50px;
  padding-top: 10px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    margin-bottom: 5px;
    padding-top: 36px;
  }
`;

export const CopyrightItem = styled.span`
  @media screen and (min-width: ${screenSizes.LARGE_SCREEN + 1}px) {
    &:not(:last-child)::after {
      content: "\\00B7"; // &middot;
      padding: 0 8px;
    }
  }
`;

export const DesktopOnly = styled.span`
  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    display: none;
  }
`;

export const Skyline = styled.img.attrs({
  alt: "Skyline footer image",
  src: skyline
})`
  height: auto;
  width: 100%;
`;

export const NeighborhoodWrapper = styled.div`
  display: flex;
  width: 100%;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    flex-direction: column;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    margin: 0 auto 29px;
    max-width: 240px;
    padding: 0 0 29px;

    ${({ isExpandedAreaSection }) =>
      !isExpandedAreaSection &&
      css`
        margin: 0 auto;
      `};
  }
`;

export const TopSection = styled.div`
  display: flex;
  width: 100%;

  ${({ isExpandedAreaSection }) =>
    !isExpandedAreaSection &&
    css`
      flex-direction: column;
    `};

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    flex-direction: column;

    ${({ isExpandedAreaSection }) =>
      !isExpandedAreaSection &&
      css`
        margin: 0 auto;
      `};
  }
`;

export const BottomSection = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const LinksWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 228px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    position: relative;
    right: auto;
    margin: 0 auto 29px;
    text-align: center;
    top: auto;
    width: 240px;
  }
`;
